<template>
  <div class="graduateDefense">
    <div class="cont-box">
      <div class="title">
        <Title text="毕业设计及答辩"/>
        <div>
          <el-form
            ref="search"
            :inline="true"
            :model="condition"
            :rules="searchRules"
            class="search-form"
            slot="search"
            label-width="80px"
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <div>
                  <el-form-item prop="paper_plan_id">
                    <el-select
                      v-model="condition.paper_plan_id"
                      placeholder="请选择论文计划"
                      clearable
                      filterable
                      style="width: 300px;"
                    >
                      <el-option
                        v-for="item in thesisPlanList"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="loadData">确认</el-button>
                  </el-form-item>
                </div>
              </div>
              <div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div v-if="isShowTble">
        <el-table
          :data="list"
          headerRowClassName="uni-primary-table-header"
          stripe
          border
          :span-method="tableSpanMethod"
        >
          <el-table-column prop="stepName" align="center" label="步骤"></el-table-column>
          <el-table-column prop="process" align="center" label="流程环节"></el-table-column>
          <el-table-column prop="week" align="center" label="周次"></el-table-column>
          <el-table-column prop="deadline" align="center" label="截止时间"></el-table-column>
          <el-table-column align="center" label="操作" width="240">
            <template slot-scope="{row, $index}">
              <div v-if="$index == 0">
                <el-button :disabled="studentInfo.is_sign == 1 || studentInfo.step != 1" class="link-btn" type="text"
                           @click="graduationRegistrationClick(row)">毕设报名
                </el-button>
                <!-- :disabled="studentInfo.is_sign != 1" -->
                <el-button :disabled="studentInfo.files_url ? false : true" type="text" @click="taskTitleClick(row)">下载任务书
                </el-button>
              </div>
              <div v-if="$index == 1">
                <div>
                  <el-button :disabled="studentInfo.is_declaration == 1 || studentInfo.step != 2" class="link-btn"
                             type="text" @click="seeInstructor(row)">查看指导老师
                  </el-button>
                  <el-button :disabled="studentInfo.step <= 2" class="link-btn"
                             type="text" @click="isShowSeeInstructorLook = true">查看
                  </el-button>
                </div>
<!--                <div>-->
<!--                  <el-button :disabled="studentInfo.is_statement == 1 || studentInfo.step < 3" class="link-btn"-->
<!--                             type="text" @click="assignmentClick(row)">填写任务书-->
<!--                  </el-button>-->
<!--                  <el-button :disabled="studentInfo.step <= 3" class="link-btn"-->
<!--                             type="text" @click="seeAssignment">查看-->
<!--                  </el-button>-->
<!--                  <el-button :disabled="studentInfo.step <= 3" class="link-btn"-->
<!--                             type="text" @click="seeAssignmentPDF">导出PDF-->
<!--                  </el-button>-->
<!--                </div>-->
                <div>
                  <!-- :disabled="studentInfo.is_report == 1 || studentInfo.step < 4" -->
                  <el-button class="link-btn"
                             type="text" @click="proposalClick(row)">开题报告
                  </el-button>
                </div>
              </div>
              <div v-if="$index == 2">
                <el-button :disabled="studentInfo.is_one == 1 || studentInfo.step != 5" class="link-btn" type="text" @click="designDataClick(1)">
                  一稿上传
                </el-button>
                <el-button :disabled="studentInfo.is_one == 0 && studentInfo.step <= 5" class="link-btn" type="text" @click="seeDesignDataClick(1)">查看</el-button>
              </div>
              <div v-if="$index == 3">
                <el-button :disabled="studentInfo.is_two == 1 || studentInfo.step != 6" class="link-btn" type="text" @click="designDataClick(2)">
                  二稿上传
                </el-button>
                <el-button :disabled="studentInfo.is_two == 0 && studentInfo.step <= 6" class="link-btn" type="text" @click="seeDesignDataClick(2)">查看</el-button>
              </div>
              <div v-if="$index == 4">
                <el-button :disabled="studentInfo.is_three == 1" class="link-btn" type="text" @click="designDataClick(3)">
                  三稿上传
                </el-button>
                <el-button :disabled="studentInfo.is_three == 0 && studentInfo.step <= 7" class="link-btn" type="text" @click="seeDesignDataClick(3)">查看</el-button>
              </div>
              <div v-if="$index == 5">
                <el-button :disabled="studentInfo.is_three == 0" class="link-btn"
                           type="text" @click="defenseApplicationClick">答辩申请
                </el-button>
              </div>
              <!-- <div v-if="$index == 7">
                <el-button v-if="studentInfo.is_defence_apply == 1 && studentInfo.step > 8" class="link-btn"
                           type="text" @click="defenceArrangementClick">答辩安排
                </el-button>
              </div> -->
              <div v-if="$index == 7">
                <el-button :disabled="studentInfo.process_status < 5" class="link-btn"
                           type="text" @click="submitApplicationClick">提交申请
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 毕设报名 -->
    <el-dialog
      class="graduationRegistration"
      title="毕业设计论文及答辩报名说明文件"
      :visible.sync="isShowGraduationRegistration"
      width="900px"
      @close="graduationRegistrationClose"
    >
      <div class="cont">
        <div class="text-box" style="border: 1px solid #ccc;padding: 10px 0 10px 10px;">
          <el-scrollbar ref="graduationRegistrationScrollbar" style="height: 500px;">
            <!-- <p style="text-align: left;">毕业答辩是学生在校学习过程中一个重要环节，是检验学生理论和实践结合能力的重要手段，答辩应充分准备，严肃认真。具体操作可按如下细则进行。</p><p style="text-align: left;"> &nbsp; &nbsp; &nbsp;一、答辩程序及要求</p><p style="text-align: left;"> &nbsp; &nbsp; 1、答辩由各答辩小组组长主持。</p><p style="text-align: left;"> &nbsp; &nbsp; 2、个人陈述设计（论文）提要或概况，陈述论文时应介绍论点、构思和主要论据，设计应介绍设计思路、主要特点及主要功能，适用范围及其它情况，时间不超过10分钟。</p><p style="text-align: left;"> &nbsp; &nbsp; 3、学生简述完毕，由答辩教师结合设计（论文）进行提问，学生就所提问题现场作回答。答辩教师可随时插问，还可考查其基础理论和专业知识，答辩学生应即席回答。</p><p style="text-align: left;"> &nbsp; &nbsp;4、答辩结束后，答辩小组就答辩情况交换意见，由答辩小组成员分别打分。</p><p style="text-align: left;"> &nbsp; &nbsp;5、答辩过程中各答辩小组秘书应负责做好记录工作。</p><p style="text-align: left;"> &nbsp; &nbsp;二、答辩纪律</p><p style="text-align: left;"> &nbsp; &nbsp;1、所有2024届高起本毕业生必须按照学院要求按时参加设计（论文）答辩，按照答辩顺序提前20分钟进入答辩教室。无故未参加毕业答辩的学生，毕业答辩成绩按零分记。</p><p style="text-align: left;"> &nbsp; &nbsp;2、答辩学生必须按照要求进行答辩。自述后，认真听取答辩教师提出的问题，依次回答各个问题，不得回避，确实回答不了的应予声明，直至答辩组成员认为答辩可以结束为止。</p><p style="text-align: left;"> &nbsp; &nbsp;三、评定标准及成绩评定</p><p style="text-align: left;"> &nbsp; &nbsp;1、评定标准</p><p style="text-align: left;"> &nbsp; &nbsp;设计（论文）答辩时表现：熟悉设计（论文）内容，语言简明扼要，对教师提出与论文相关的问题能正确解答；</p><p style="text-align: left;">解答问题时思维敏捷，表达流利。</p><p style="text-align: left;"> &nbsp; &nbsp;2、成绩评定</p><p style="text-align: left;"> &nbsp; &nbsp;（1）学生的答辩成绩由答辩组教师集体讨论。由每位老师打分后，取平均分为该学生的答辩成绩。</p><p style="text-align: left;"> &nbsp; &nbsp;（2）学生毕业设计（论文）综合评定成绩由指导教师评阅成绩、答辩成绩两部分组成。答辩完成后由指导教师完成综合评定，填写学生毕业论文成绩总表。</p> -->
            <pdf
              :src="pdfUrl"
              :page="pdfCurrPage"
              @num-pages="numPagesFun"
            ></pdf>
            <div class="page-box">
              <span class="text">第 {{ pdfCurrPage }} 页</span>
              <span class="text">总页数：{{ pdfPageTotal }}</span>
              <el-button type="primary" size="mini" :disabled="pdfCurrPage <= 1" @click="pdfPrev">上一页</el-button>
              <el-button type="primary" size="mini" :disabled="pdfCurrPage >= pdfPageTotal" @click="pdfNext">下一页
              </el-button>
            </div>
          </el-scrollbar>
        </div>
        <el-form
          ref="graduationRegistrationRef"
          :model="graduationRegistrationData"
          :rules="graduationRegistrationRules"
          label-width="160px"
          label-position="left"
          style="margin-top: 10px;"
        >
          <div style="display: flex;justify-content: space-between;">
            <el-form-item label="" prop="is_read" label-width="0" style="width: 200px;">
              <el-checkbox v-model="graduationRegistrationData.is_read" :true-label="1" false-label="">我已阅读
              </el-checkbox>
            </el-form-item>
            <el-form-item label="手写签名:" prop="student_sign_img" label-width="100px">
              <esignHandle
                ref="esignHandle"
                :selectSignImg.sync="graduationRegistrationData.student_sign_img"
                @selectSignImgAfter="studentSignImgAfter($event, 'graduationRegistrationRef', 'student_sign_img')"
              ></esignHandle>
            </el-form-item>
          </div>
          <el-form-item label="是否有需要学位意愿:" prop="is_degree">
            <el-radio-group v-model="graduationRegistrationData.is_degree">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="graduationRegistrationData.is_degree == 1" style="display: flex;justify-content: space-between;">
            <el-form-item label="计算机成绩照片:" prop="computer_score_img">
              <FalConUpload
                ref="uploadComputerScoreImg"
                :limit="1"
                @handleRemove="degreeFileRemove($event, 'computer_score_img', 'graduationRegistrationData')"
                @handleChange="degreeFileChange($event, 'computer_score_img', 'graduationRegistrationData')"
              ></FalConUpload>
            </el-form-item>
            <el-form-item label="英语成绩照片:" prop="english_score_img">
              <FalConUpload
                ref="uploadEnglishScoreImg"
                :limit="1"
                @handleRemove="degreeFileRemove($event, 'english_score_img', 'graduationRegistrationData')"
                @handleChange="degreeFileChange($event, 'english_score_img', 'graduationRegistrationData')"
              ></FalConUpload>
            </el-form-item>
            <el-form-item label="平均成绩照片:" prop="average_score_img">
              <FalConUpload
                ref="uploadaverageScoreImg"
                :limit="1"
                @handleRemove="degreeFileRemove($event, 'average_score_img', 'graduationRegistrationData')"
                @handleChange="degreeFileChange($event, 'average_score_img', 'graduationRegistrationData')"
              ></FalConUpload>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <el-button @click="isShowGraduationRegistration = false">关闭</el-button>
        <el-button type="primary" @click="graduationRegistrationSubmit">确认报名</el-button>
      </div>
    </el-dialog>
    <!-- 查看指导老师 -->
    <el-dialog
      class="seeInstructor"
      :title="`指导教师：${studentInfo.teacher_title}`"
      :visible.sync="isShowSeeInstructor"
      width="900px"
      @close="seeInstructorClose"
    >
      <div class="cont">
        <el-form
          ref="seeInstructorRef"
          :model="seeInstructorData"
          :rules="seeInstructorRules"
          label-width="110px"
          label-position="left"
        >
          <div class="floor">
            <div class="floor-title">本科毕业论文（设计）原创性声明</div>
            <div class="floor-text">
              <p class="text">
                本人郑重声明：所提交的毕业论文（设计），是本人在导师指导下，独立进行研究工作所取得的成果。除文中已注明引用的内容外，本论文不包含任何其他个人或集体已经发表或撰写过的作品成果。对本文研究做出过重要贡献的个人和集体，均已在文中以明确方式标明。</p>
              <p class="text">本人完全意识到本声明的法律后果由本人承担。</p>
            </div>
            <div class="floor-bot">
              <el-form-item label="作者手写签名:" prop="declaration_sign_img">
                <esignHandle
                  ref="esignHandle1"
                  :selectSignImg.sync="seeInstructorData.declaration_sign_img"
                  @selectSignImgAfter="studentSignImgAfter($event, 'seeInstructorRef', 'declaration_sign_img')"
                ></esignHandle>
              </el-form-item>
              <el-form-item label="" prop="sign_data">
                <div class="date-box">
                  <span class="text value">{{ seeInstructorData.declarationDate.year }}</span>
                  <!-- <el-input class="input" v-model="seeInstructorData.declarationDate.year" placeholder="" @input="inputChange($event, 'sign_data', 'seeInstructorData', 'declarationDate')"></el-input> -->
                  <span class="text">年</span>
                  <span class="text value">{{ seeInstructorData.declarationDate.month }}</span>
                  <!-- <el-input class="input" v-model="seeInstructorData.declarationDate.month" placeholder="" @input="inputChange($event, 'sign_data', 'seeInstructorData', 'declarationDate')"></el-input> -->
                  <span class="text">月</span>
                  <span class="text value">{{ seeInstructorData.declarationDate.day }}</span>
                  <!-- <el-input class="input" v-model="seeInstructorData.declarationDate.day" placeholder="" @input="inputChange($event, 'sign_data', 'seeInstructorData', 'declarationDate')"></el-input> -->
                  <span class="text">日</span>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="floor">
            <div class="floor-title">本科毕业论文（设计）版权使用授权书</div>
            <div class="floor-text">
              <p class="text">
                本毕业论文（设计）作者完全了解学校有关保留、使用学位论文的规定，本科生在校攻读期间毕业论文（设计）工作的知识产权单位属重庆医科大学，同意学校保留并向国家有关部门或机构送交论文的复印件和电子版，允许论文被查阅和借阅；本人授权重庆医科大学可以将毕业论文（设计）的全部或部分内容编入有关数据库进行检索，可以采用影印、缩印或扫描等复制手段保存、汇编毕业设计（论文）。。</p>
            </div>
            <div class="floor-bot">
              <el-form-item label="作者手写签名:" prop="authorize_sign_img">
                <esignHandle
                  ref="esignHandle2"
                  :selectSignImg.sync="seeInstructorData.authorize_sign_img"
                  @selectSignImgAfter="studentSignImgAfter($event, 'seeInstructorRef', 'authorize_sign_img')"
                ></esignHandle>
              </el-form-item>
              <el-form-item label="" prop="authorize_sign_data">
                <div class="date-box">
                  <span class="text value">{{ seeInstructorData.authorizeDate.year }}</span>
                  <!-- <el-input class="input" v-model="seeInstructorData.authorizeDate.year" placeholder="" @input="inputChange($event, 'authorize_sign_data', 'seeInstructorData', 'authorizeDate')"></el-input> -->
                  <span class="text">年</span>
                  <span class="text value">{{ seeInstructorData.authorizeDate.month }}</span>
                  <!-- <el-input class="input" v-model="seeInstructorData.authorizeDate.month" placeholder="" @input="inputChange($event, 'authorize_sign_data', 'seeInstructorData', 'authorizeDate')"></el-input> -->
                  <span class="text">月</span>
                  <span class="text value">{{ seeInstructorData.authorizeDate.day }}</span>
                  <!-- <el-input class="input" v-model="seeInstructorData.authorizeDate.day" placeholder="" @input="inputChange($event, 'authorize_sign_data', 'seeInstructorData', 'authorizeDate')"></el-input> -->
                  <span class="text">日</span>
                </div>
              </el-form-item>
            </div>
            <div class="floor-bot">
              <el-form-item label="导师手写签名:" prop="">

              </el-form-item>
              <div class="date-box">
                <el-input class="input" v-model="seeInstructorData.mentorDate.year" readonly placeholder=""></el-input>
                <span class="text">年</span>
                <el-input class="input" v-model="seeInstructorData.mentorDate.month" readonly placeholder=""></el-input>
                <span class="text">月</span>
                <el-input class="input" v-model="seeInstructorData.mentorDate.day" readonly placeholder=""></el-input>
                <span class="text">日</span>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <el-button @click="isShowSeeInstructor = false">关闭</el-button>
        <el-button type="primary" @click="seeInstructorSubmit">确认签署</el-button>
      </div>
    </el-dialog>
    <!--   查看指导老师-查看   -->
    <el-dialog
      class="seeInstructor"
      :title="`指导教师：${studentInfo.teacher_title} 联系电话：${studentInfo.teacher_mobile}`"
      :visible.sync="isShowSeeInstructorLook"
      width="900px"
      @close="isShowSeeInstructorLook = false"
    >

      <div style="text-align: center;margin-top: 20px;">
        <el-button @click="isShowSeeInstructorLook = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 填写任务书 -->
    <el-dialog
      class="assignment"
      title=""
      :visible.sync="isShowAssignment"
      width="900px"
      :close-on-click-modal="false"
      @close="assignmentClose"
    >
      <div class="cont">
        <el-form
          ref="assignmentRef"
          :model="assignmentData"
          :rules="assignmentRules"
          label-position="left"
        >
          <div class="floor border-b">
            <p class="cont-title">重庆医科大学毕业论文（设计）任务书</p>
          </div>
          <div class="floor border-b info-box">
            <div class="item border-r">
              <span class="name">姓名：</span>
              <span class="value">{{ studentInfo.student_title }}</span>
            </div>
            <div class="item border-r">
              <span class="name">学号：</span>
              <span class="value">{{ studentInfo.student_code }}</span>
            </div>
            <div class="item">
              <span class="name">指导教师：</span>
              <span class="value">{{ studentInfo.teacher_title }}</span>
            </div>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title">题目：</p>
            <el-form-item label="" prop="title">
              <el-input
                type="textarea"
                v-model="assignmentData.title"
                placeholder="请输入题目"
                :rows="4"
                :maxlength="500"
                resize="none"
                show-word-limit
                :readonly="isShowAssignmentSubmit"
              ></el-input>
            </el-form-item>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title">主要内容：</p>
            <el-form-item label="" prop="content">
              <el-input
                type="textarea"
                v-model="assignmentData.content"
                placeholder="备注：此处分条写明毕业设计（论文）选题的具体内容，设计类选题明确设计参数和相关指标要求。"
                :rows="4"
                resize="none"
                show-word-limit
                :readonly="isShowAssignmentSubmit"
              ></el-input>
            </el-form-item>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title">任务要求：</p>
            <el-form-item label="" prop="requirements">
              <el-input
                type="textarea"
                v-model="assignmentData.requirements"
                placeholder="备注：此处分条罗列各阶段需完成的主要任务及其质量要求，包括调研、建模、分析、计算、设计、绘图等明确内容及具体要求，不能简单照搬规范要求，且明确主要任务与课程目标、毕业要求内涵观测点的支撑对应关系。"
                :rows="4"
                resize="none"
                show-word-limit
                :readonly="isShowAssignmentSubmit"
              ></el-input>
            </el-form-item>
          </div>
          <div class="floor border-b table">
            <p class="item-title">进度计划：</p>
            <div class="table-cont">
              <table class="table-box">
                <tr>
                  <th class="cell week">周次</th>
                  <th class="cell">主要工作计划（内容）</th>
                  <th v-if="!isShowAssignmentSubmit" class="cell operate">操作</th>
                </tr>
                <tr v-for="(item, index) in assignmentData.content_plan" :key="index">
                  <td class="cell week">
                    <el-form-item :prop="`content_plan.${index}.week`" :rules="{ required: true, message: '周次！' }">
                      <el-input v-model="item.week" :readonly="isShowAssignmentSubmit" placeholder="周次"></el-input>
                    </el-form-item>
                  </td>
                  <td class="cell cont">
                    <el-form-item :prop="`content_plan.${index}.cont`" :rules="{ required: true, message: '请输入内容！' }">
                      <el-input v-model="item.cont" :readonly="isShowAssignmentSubmit" placeholder="请输入内容" clearable></el-input>
                    </el-form-item>
                  </td>
                  <td v-if="!isShowAssignmentSubmit" class="cell">
                    <el-button v-if="index == assignmentData.content_plan.length - 1" type="primary" size="mini"
                               @click="contentPlanAdd">添加
                    </el-button>
                    <el-button v-if="assignmentData.content_plan.length > 1" type="danger" size="mini"
                               @click="contentPlanDel(index)">删除
                    </el-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="floor bot">
            <div class="item">
              <el-form-item label="接受任务日期：" label-width="124px" prop="accept_date">
                <el-input v-model="assignmentData.accept_date" :readonly="isShowAssignmentSubmit" placeholder="请输入接受任务日期" clearable></el-input>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="要求完成日期：" label-width="124px" prop="complete_date">
                <el-input v-model="assignmentData.complete_date" :readonly="isShowAssignmentSubmit" placeholder="请输入要求完成日期" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="floor bot">
            <div class="item">
              <el-form-item label="学生接受任务（签名）:" label-width="180px" prop="student_sign_img">
                <!-- :preview-src-list="[assignmentData.student_sign_img]" -->
                <el-image
                    v-if="isShowAssignmentSubmit"
                    class="see-img"
                    :src="assignmentData.student_sign_img"
                >
                </el-image>
                <esignHandle
                  v-else
                  ref="esignHandle3"
                  :selectSignImg.sync="assignmentData.student_sign_img"
                  @selectSignImgAfter="studentSignImgAfter($event, 'assignmentRef', 'student_sign_img')"
                ></esignHandle>
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="指导教师签名：" label-width="124px" prop="teacher_sign_img">
                <el-image
                    v-if="isShowAssignmentSubmit"
                    class="see-img"
                    :src="assignmentData.teacher_sign_img"
                >
                </el-image>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <el-button @click="isShowAssignment = false">关闭</el-button>
        <el-button v-if="!isShowAssignmentSubmit" type="primary" @click="assignmentSubmit">确认提交</el-button>
      </div>
    </el-dialog>

    <!-- 任务书PDF -->
    <el-dialog
      class="assignment"
      title=""
      :visible.sync="isShowAssignmentPDF"
      width="900px"
      :close-on-click-modal="false"
      @close="isShowAssignmentPDF = false"
    >
      <div ref="assignmentRefPDF" class="assignmentPDF">
        <el-form
          :model="assignmentData"
          label-position="left"
        >
          <div class="floor border-b">
            <p class="cont-title">重庆医科大学毕业论文（设计）任务书</p>
          </div>
          <div class="floor border-b info-box">
            <div class="item border-r">
              <span class="name">姓名：</span>
              <span class="value">{{ studentInfo.student_title }}</span>
            </div>
            <div class="item border-r">
              <span class="name">学号：</span>
              <span class="value">{{ studentInfo.student_code }}</span>
            </div>
            <div class="item">
              <span class="name">指导教师：</span>
              <span class="value">{{ studentInfo.teacher_title }}</span>
            </div>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title">题目：</p>
            <el-form-item label="" prop="title">
              <p style="padding: 5px 15px;white-space: pre-wrap;">{{ assignmentData.title }}</p>
              <!-- <el-input
                type="textarea"
                v-model="assignmentData.title"
                :rows="4"
                :maxlength="500"
                resize="none"
                show-word-limit
                :readonly="true"
              ></el-input> -->
            </el-form-item>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title">主要内容：</p>
            <el-form-item label="" prop="content">
              <p style="padding: 5px 15px;white-space: pre-wrap;">{{ assignmentData.content }}</p>
              <!-- <el-input
                type="textarea"
                v-model="assignmentData.content"
                placeholder="备注：此处分条写明毕业设计（论文）选题的具体内容，设计类选题明确设计参数和相关指标要求。"
                :rows="4"
                resize="none"
                show-word-limit
                :readonly="true"
              ></el-input> -->
            </el-form-item>
          </div>
          <div class="floor border-b textarea">
            <p class="item-title">任务要求：</p>
            <el-form-item label="" prop="requirements">
              <p style="padding: 5px 15px;white-space: pre-wrap;">{{ assignmentData.requirements }}</p>
              <!-- <el-input
                type="textarea"
                v-model="assignmentData.requirements"
                placeholder="备注：此处分条罗列各阶段需完成的主要任务及其质量要求，包括调研、建模、分析、计算、设计、绘图等明确内容及具体要求，不能简单照搬规范要求，且明确主要任务与课程目标、毕业要求内涵观测点的支撑对应关系。"
                :rows="4"
                resize="none"
                show-word-limit
                :readonly="true"
              ></el-input> -->
            </el-form-item>
          </div>
          <div class="floor border-b table">
            <p class="item-title">进度计划：</p>
            <div class="table-cont">
              <table class="table-box">
                <tr>
                  <th class="cell week">周次</th>
                  <th class="cell">主要工作计划（内容）</th>
                </tr>
                <tr v-for="(item, index) in assignmentData.content_plan" :key="index">
                  <td class="cell week">
                    {{ item.week }}
                    <!-- <el-form-item :prop="`content_plan.${index}.week`" :rules="{ required: true, message: '周次！' }">
                      <el-input v-model="item.week" :readonly="true" placeholder="周次"></el-input>
                    </el-form-item> -->
                  </td>
                  <td class="cell cont">
                    {{ item.cont }}
                    <!-- <el-form-item :prop="`content_plan.${index}.cont`" :rules="{ required: true, message: '请输入内容！' }">
                      <el-input v-model="item.cont" :readonly="true" placeholder="请输入内容" clearable></el-input>
                    </el-form-item> -->
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="floor bot">
            <div class="item">
              <el-form-item label="接受任务日期：" label-width="124px" prop="accept_date">
                <span>{{ assignmentData.accept_date }}</span>
                <!-- <el-input v-model="assignmentData.accept_date" :readonly="true" placeholder="请输入接受任务日期" clearable></el-input> -->
              </el-form-item>
            </div>
            <div class="item">
              <el-form-item label="要求完成日期：" label-width="124px" prop="complete_date">
                <span>{{ assignmentData.complete_date }}</span>
                <!-- <el-input v-model="assignmentData.complete_date" :readonly="true" placeholder="请输入要求完成日期" clearable></el-input> -->
              </el-form-item>
            </div>
          </div>
          <div class="floor bot">
            <div class="item">
              <el-image
                :src="assignmentData.student_sign_img"
                style="width: 50px;height: 50px;"
              >
              </el-image>
            </div>
            <div class="item">
              <el-image
                :src="assignmentData.teacher_sign_img"
                style="width: 50px;height: 50px;"
              >
                </el-image>
            </div>
          </div>
        </el-form>
      </div>

      <div style="text-align: center;margin-top: 20px;">
        <el-button @click="isShowAssignmentPDF = false">关闭</el-button>
        <el-button @click="assignmentExportPDF">导出PDF</el-button>
      </div>
    </el-dialog>

    <!-- 查看任务书 -->
    <el-dialog
      title="查看任务书"
      :visible.sync="isShowAssignmentLook"
      width="30%"
      @close="assignmentLookClose"
    >
      <div class="dialog">
        <div v-for="(item, index) in assignmentList" :key="index">
          <span>{{ item.name }}</span>
          <el-button
            type="text"
            style="margin-left: 10px;"
            @click="downloadAssignment(item)"
          >下载
          </el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowAssignmentLook = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 一稿上传/二稿上传/三稿上传 -->
    <el-dialog
        class="designData"
        :title="(designType == 1 && '一稿上传') || (designType == 2 && '二稿上传') || (designType == 3 && '三稿上传')"
        :visible.sync="isShowDesignData"
        width="40%"
        @close="designDataClose"
      >
        <div class="dialog" >
          <el-form
            ref="designDataRef"
            :model="designDataData"
            :rules="designDataRules"
            label-width="200px"
          >
            <el-form-item label="设计资料文件:" prop="files_url">
              <FalConUpload
                ref="designDataUploadFile"
                listStyle='text'
                accept=".pdf,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx"
                :limit='20'
                :multiple="true"
                :isFile="true"
                :isAccept="false"
                @handleRemove="handleRemoveFile"
                @handleChange="handleChangeFile"
              >
              </FalConUpload>
              <div class="tips">说明：可上传PDF文档，压缩文件或OFFICE文档</div>
            </el-form-item>
            <!-- <el-form-item label="设计资料图片" prop="imgs_url">
              <FalConUpload
                ref="uploadPaperPictures"
                :multiple="true"
                :limit="20"
                :isShowModal="false"
                @handleRemove="paperPicturesHandleRemove"
                @handleChange="paperPicturesHandleChange"
              ></FalConUpload>
            </el-form-item> -->
            <el-form-item label="手写签名:" prop="sign_img">
              <esignHandle
                ref="esignHandleDesignData"
                :selectSignImg.sync="designDataData.sign_img"
                @selectSignImgAfter="studentSignImgAfter($event, 'designDataRef', 'sign_img')"
              ></esignHandle>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center">
          <el-button @click="isShowDesignData = false">取 消</el-button>
          <el-button type="primary" @click="designDataSubmit">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  adultStudentPpAll,
  studentSubmitSign,
  studentSubmitDeclaration,
  studentPpsInfo,
  studentSubmitStatement,
  studentGetStatement,
  adultStudentPpsUpDevise,
} from "@/api/graduation";
import {putObject, uploadFiles, deleteObject} from "@/utils/upload";

import {arrAttDel, deepClone, goFirstError} from '@/utils/func';

import {downladUrl} from '@/utils/func';

import esignHandle from '@/components/esignHandle';
import FalConUpload from "@/components/uploadFile";
import html2pdf from 'html2pdf.js'

import pdf from 'vue-pdf'

export default {
  name: "graduateDefense",
  components: {esignHandle, FalConUpload, pdf},
  filters: {},
  data() {
    return {
      condition: {
        paper_plan_id: '',  //论文计划
      },
      searchRules: {
        paper_plan_id: [{required: true, message: "请选择论文计划", trigger: "change"}],
      },
      thesisPlanList: [],  //论文计划列表

      list: [
        {stepName: '第一步', process: '毕设报名', week: '第1周', deadline: '2025年1月22日24点'},
        {stepName: '第二步', process: '任务开题', week: '第2~3周', deadline: '2025年2月9日24点'},
        {stepName: '第三步', process: '毕设撰写', week: '第4-5周', deadline: '2025年2月23日24点'},
        {stepName: '第三步', process: '毕设撰写', week: '第4-5周', deadline: '2025年3月2日24点'},
        {stepName: '第三步', process: '毕设撰写', week: '第4-5周', deadline: '2025年3月16日24点'},
        {stepName: '第四步', process: '答辩申请', week: '第9周', deadline: '2025年3月23日24点'},
        {stepName: '第五步', process: '交叉评阅', week: '第10周', deadline: '2025年3月30日24点'},
        {stepName: '第六步', process: '毕设答辩', week: '第11周', deadline: '2025年4月5日6日'},
        {stepName: '第七步', process: '成绩申请', week: '第12周', deadline: '2025年4月13日24点'},
      ],
      listTotal: -1,

      isShowTble: false, //显示表格

      // 学生详情
      studentInfo: {
        student_title: '',  //学生姓名
        teacher_title: '',  //指导老师姓名
        teacher_mobile: '',  //指导老师电话
        is_degree: '',  //是否需要学位 0否 1是
        is_sign: '',  //是否报名 0否 1是
        is_declaration: '',  //是否提交声明 0否 1是
        is_statement: '',  //是否提交任务书 0否 1是
        is_report: '',  //是否提交开题报告 0否 1是
        is_one: '',  //一稿状态 0未提交 1已提交
        is_two: '',  //二稿状态 0未提交 1已提交
        is_three: '',  //三稿状态 0未提交 1已提交
        is_defence_apply: '',  //答辩申请 0未提交 1已提交
        is_score_reply: '',  //成绩申请 0未提交 1已提交
        sign_deadline: '',  //毕设报名截止时间
        report_deadline: '',  //任务开题截止时间
        one_deadline: '',  //一稿上传截止时间
        two_deadline: '',  //二稿上传截止时间
        three_deadline: '',  //三稿上传截止时间
        defense_reply_deadline: '',  //答辩申请截止时间
        cross_deadline: '',  //交叉评阅截止时间
        defense_deadline: '',  //毕设答辩截止时间
        score_reply_deadline: '',  //成绩申请截止时间
        step: '',  //步骤
      },

      // 毕设报名
      isShowGraduationRegistration: false,
      graduationRegistrationData: {
        paper_plan_student_id: '',  //学生毕业设计及答辩id
        is_read: '',  //是否阅读报名须知 0否 1是
        student_sign_img: '',  //学生手写签名
        is_degree: 0,  //是否需要学位 0否 1是
        computer_score_img: '',  //计算机成绩照片
        english_score_img: '',  //英语成绩照片
        average_score_img: '',  //平均成绩照片
      },
      graduationRegistrationRules: {
        is_read: [{required: true, trigger: 'change', message: "请勾选我已阅读"}],
        student_sign_img: [{required: true, trigger: 'change', message: "请添加手写签名"}],
        is_degree: [{required: true, trigger: 'chagen', message: "请选择是否需要学位"}],
        // computer_score_img: [{ required: true, trigger: 'chagen', message: "请上传计算机成绩照片" }],
        // english_score_img: [{ required: true, trigger: 'chagen', message: "请上传英语成绩照片" }],
        // average_score_img: [{ required: true, trigger: 'chagen', message: "请上传平均成绩照片" }],
      },
      pdfUrl: 'https://www.cqjtjxjy.com/student/2025-1/173701136347415.pdf',
      pdfPageTotal: 0,  //pdf文件总页数
      pdfCurrPage: 1,  //pdf当前页

      // 查看指导老师
      isShowSeeInstructor: false,
      seeInstructorData: {
        paper_plan_student_id: '',  //学生毕业设计及答辩id
        declaration_sign_img: '',  //原创性声明学生手写签名
        sign_data: '',  //签名日期
        authorize_sign_img: '',  //授权书学生手写签名
        authorize_sign_data: '',  //授权书签名日期
        // 原创性日期
        declarationDate: {
          year: '',  //签名日期 年
          month: '',  //签名日期 月
          day: '',  //签名日期 日
        },
        // 授权书学生日期
        authorizeDate: {
          year: '',  //签名日期 年
          month: '',  //签名日期 月
          day: '',  //签名日期 日
        },
        // 授权书导师日期
        mentorDate: {
          year: '',  //签名日期 年
          month: '',  //签名日期 月
          day: '',  //签名日期 日
        },
      },
      seeInstructorRules: {
        declaration_sign_img: [{required: true, trigger: 'change', message: "请添加手写签名"}],
        sign_data: [{required: true, trigger: 'blur', message: "请填写时间"}],
        authorize_sign_img: [{required: true, trigger: 'change', message: "请添加手写签名"}],
        authorize_sign_data: [{required: true, trigger: 'blur', message: "请填写时间"}],
      },

      //指导老师查看
      isShowSeeInstructorLook: false,

      // 填写任务书
      isShowAssignment: false,
      assignmentData: {
        paper_plan_student_id: '',  //学生毕业设计及答辩id
        title: '',  //题目
        content: '',  //主要内容
        requirements: '',  //任务要求
        content_plan: [
          {week: '', cont: ''},
        ],  //工作计划
        accept_date: '',  //接受日期
        complete_date: '',  //完成日期
        student_sign_img: '',  //学生手写签名
        teacher_sign_img: '',  //指导老师签名
      },
      assignmentRules: {
        title: [{required: true, trigger: 'blur', message: "请输入标题"}],
        content: [{required: true, trigger: 'blur', message: "请输入主要内容"}],
        requirements: [{required: true, trigger: 'blur', message: "请输入任务要求"}],
        accept_date: [{required: true, trigger: 'blur', message: "请输入接受任务日期"}],
        complete_date: [{required: true, trigger: 'blur', message: "请输入要求完成日期"}],
        student_sign_img: [{required: true, trigger: 'blur', message: "请添加学生接受任务（签名）"}],
      },
      //任务书PDF
      isShowAssignmentPDF: false,

      // 查看任务书
      isShowAssignmentLook: false,
      assignmentList: [],

      // 查看提交的任务书
      isShowAssignmentSubmit: false,

      designType: 1,  //一二三搞上传类型

      // 一二三搞上传
      isShowDesignData: false,
      designDataData: {
        paper_plan_student_id: '',  //论文计划学生id
        files_url: '',  //任务书及开题报告文件/设计资料文件
        // imgs_url: '',  //任务书及开题报告图片/设计资料图片
        sign_img: '',  //手写签名图片地址
        num: '',  //类型 一二三搞
      },
      designDataRules: {
        files_url: [{ required: true, message: '请上传设计资料文件', trigger: 'change' }],
        // imgs_url: [{ required: true, message: '请上传设计资料图片', trigger: 'change' }],
        sign_img: [{ required: true, message: '请添加手写签名', trigger: 'change' }],
      },

    };
  },
  computed: {
    ...mapState("common", {
      cached: (state) => state.cached,
    }),
  },
  watch: {},
  created() {
    this.getThesisPlanList();
  },
  mounted(){
    if(this.cached.isBack){
      const {data} = this.cached;
      this.condition = data;
      this.$nextTick(() => {
        this.loadData();
        const cachedData = {
          isBack: false,
          page: '',  //缓存的页面
          data: {},  //缓存数据
        };
        this.$store.commit("common/getCachedMutations", cachedData);
      });
    }
  },
  methods: {
    // 提交申请
    submitApplicationClick(){
      const cachedData = {
        isBack: false,
        page: 'gradeApplication',  //缓存的页面
        data: this.condition,  //缓存数据
      };
      this.$store.commit("common/getCachedMutations", cachedData);
      this.$router.push({
        name: "gradeApplication",
        query: {
          id: this.condition.paper_plan_id,
        },
      });
    },
    // 答辩安排
    defenceArrangementClick(){
      const cachedData = {
        isBack: false,
        page: 'defenseSession',  //缓存的页面
        data: this.condition,  //缓存数据
      };
      this.$store.commit("common/getCachedMutations", cachedData);
      this.$router.push({
        name: "defenseSession",
        // query: {
        // },
      });
    },
    // 答辩申请
    defenseApplicationClick(){
      const cachedData = {
        isBack: false,
        page: 'reply',  //缓存的页面
        data: this.condition,  //缓存数据
      };
      this.$store.commit("common/getCachedMutations", cachedData);
      this.$router.push({
        name: "reply",
        query: {
          id: this.condition.paper_plan_id,
        },
      });
    },
    // 查看 一二三搞 跳转页面
    seeDesignDataClick(){
      const cachedData = {
        isBack: false,
        page: 'viewOpeningReportAE',  //缓存的页面
        data: this.condition,  //缓存数据
      };
      this.$store.commit("common/getCachedMutations", cachedData);
      this.$router.push({
        name: "viewOpeningReportAE",
        query: {
          paper_plan_student_id: this.condition.paper_plan_id
        },
      });
    },
    // 一二三稿上传 提交
    designDataSubmit(){
      this.$refs["designDataRef"].validate((valid) => {
        if (valid) {
          uploadFiles(this.designDataData.files_url, (urls) => {
            let data = deepClone(this.designDataData);
            data.files_url = urls;
            adultStudentPpsUpDevise(data).then(res => {
              if(res.code == 200){
                this.$message.success('保存成功');
                this.isShowDesignData = false;
                this.getStudentPpsInfoData();
              }
            });
          }, null, 'student', '', true);
        }
      })
    },
    // 弹窗 一二三稿上传 关闭
    designDataClose(){
      this.openingReportData = {
        paper_plan_student_id: '',  //论文计划学生id
        files_url: '',  //任务书及开题报告文件/设计资料文件
        // imgs_url: '',  //任务书及开题报告图片/设计资料图片
        sign_img: '',  //手写签名图片地址
        num: '',  //类型 一二三搞
      };
      this.$refs['designDataUploadFile'].reset();
      if(this.$refs['esignHandleDesignData']){
        this.$refs['esignHandleDesignData'].handleReset();  //签名这块清空
      }
      this.$nextTick(() => {
        this.$refs['designDataRef'].clearValidate();
      });
    },
    // 上传 一二三稿上传
    handleChangeFile(data) {
      this.designDataData.files_url = data.fileList;
      this.$refs['designDataRef'].validateField('files_url');
    },
    //  删除 一二三稿上传
    handleRemoveFile(data) {
      this.designDataData.files_url = data.fileList;
    },
    // 一二三稿上传
    designDataClick(num){
      this.designDataData.paper_plan_student_id = this.condition.paper_plan_id;
      this.designDataData.num = num;
      this.designType = num;
      this.isShowDesignData = true;
    },
    // 获取任务书数据
    getAssignmentData(){
      return new Promise((resolve,reject) => {
        const data = {
          paper_plan_student_id: this.condition.paper_plan_id,
        };
        studentGetStatement(data).then(res => {
          if (res.code === 200) {
            const {
              paper_plan_student_id,  //学生毕业设计及答辩id
              title,  //题目
              content,  //主要内容
              requirements,  //任务要求
              content_plan,  //工作计划
              accept_date,  //接受日期
              complete_date,  //完成日期
              student_sign_img,  //学生手写签名
              teacher_sign_img, //指导老师签名
            } = res.result;
            this.assignmentData = {
              paper_plan_student_id,  //学生毕业设计及答辩id
              title,  //题目
              content,  //主要内容
              requirements,  //任务要求
              content_plan: JSON.parse(content_plan),  //工作计划
              accept_date,  //接受日期
              complete_date,  //完成日期
              student_sign_img,  //学生手写签名
              teacher_sign_img, //指导老师签名
            };
            resolve(true);
          }
        });
      });
    },
    // 查看任务书
    seeAssignment(){
      this.getAssignmentData().then(res => {
        this.isShowAssignmentSubmit = true;
        this.isShowAssignment = true;
      });
    },
    // 弹窗 查看任务书 下载
    downloadAssignment(row) {
      downladUrl(row.url, row.name);
    },
    // 弹窗 查看任务书 关闭
    assignmentLookClose() {
      this.assignmentList = [];
    },
    // 点击任务书查看文件 查看任务书
    taskTitleClick() {
      this.assignmentList = JSON.parse(this.studentInfo.files_url);
      this.isShowAssignmentLook = true;
    },
    // 任务书PDF
    seeAssignmentPDF(){
      this.getAssignmentData().then(res => {
        this.isShowAssignmentPDF = true;
      });
    },
    //点击导出任务书为PDF
    assignmentExportPDF() {
      // const assignmentRef = ref(null)
      const opt = {
        margin: 0.5,
        filename: '任务书.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
      }
      // console.log(this.$refs.assignmentRefPDF)
      html2pdf().set(opt).from(this.$refs.assignmentRefPDF).save()
    },
    //   弹窗 毕设报名 pdf文件 上一页
    pdfPrev() {
      if (this.pdfCurrPage > 1) {
        this.pdfCurrPage -= 1;
        this.$refs['graduationRegistrationScrollbar'].wrap.scrollTo(0, 0);
      }
    },
    //   弹窗 毕设报名 pdf文件 下一页
    pdfNext() {
      if (this.pdfCurrPage < this.pdfPageTotal) {
        this.pdfCurrPage += 1;
        this.$refs['graduationRegistrationScrollbar'].wrap.scrollTo(0, 0);
      }
    },
    // 弹窗 毕设报名 pdf文件总页数
    numPagesFun(v) {
      if (v) {
        this.pdfPageTotal = v;
      }
    },
    // 获取年月日
    getDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return {
        year,
        month,
        day,
      };
    },

    //  点击开题报告
    proposalClick() {
      const cachedData = {
        isBack: false,
        page: 'openingReport',  //缓存的页面
        data: this.condition,  //缓存数据
      };
      this.$store.commit("common/getCachedMutations", cachedData);

      this.$router.push({
        name: "openingReport",
        query: {
          paper_plan_student_id: this.condition.paper_plan_id,
        },
      });
    },
    // 弹窗 填写任务书 提交
    assignmentSubmit() {
      this.$refs["assignmentRef"].validate((valid) => {
        if (valid) {
          const data = deepClone(this.assignmentData);
          data.content_plan = JSON.stringify(data.content_plan);
          studentSubmitStatement(data).then(res => {
            if (res.code == 200) {
              this.$message.success('提交成功');
              this.isShowAssignment = false;
              this.getStudentPpsInfoData();
            }
          });
        } else {
          goFirstError();
        }
      });
    },
    // 弹窗 填写任务书 关闭
    assignmentClose() {
      this.assignmentData = {
        paper_plan_student_id: '',  //学生毕业设计及答辩id
        title: '',  //题目
        content: '',  //主要内容
        requirements: '',  //任务要求
        content_plan: [
          {week: '', cont: ''},
        ],  //工作计划
        accept_date: '',  //接受日期
        complete_date: '',  //完成日期
        student_sign_img: '',  //学生手写签名
      };
      if(this.$refs['esignHandle3']){
        this.$refs['esignHandle3'].handleReset();  //签名这块清空
      }
      this.$nextTick(() => {
        this.$refs['assignmentRef'].clearValidate();
      });
    },
    // 弹窗 填写任务书 进度计划 添加
    contentPlanAdd() {
      const obj = {
        week: '',  //周次
        cont: '',  //内容
      };
      this.assignmentData.content_plan.push(obj);
    },
    // 弹窗 填写任务书 进度计划 删除
    contentPlanDel(index) {
      this.assignmentData.content_plan.splice(index, 1);
    },
    // 填写任务书
    assignmentClick() {
      this.isShowAssignmentSubmit = false;
      this.assignmentData.paper_plan_student_id = this.condition.paper_plan_id;
      this.isShowAssignment = true;
    },
    // 查看指导老师
    seeInstructor() {
      this.seeInstructorData.paper_plan_student_id = this.condition.paper_plan_id;
      const date = this.getDate();
      this.seeInstructorData.sign_data = `${date.year}-${date.month}-${date.day}`;
      this.seeInstructorData.declarationDate = {
        year: date.year,
        month: date.month,
        day: date.day,
      };
      this.seeInstructorData.authorize_sign_data = `${date.year}-${date.month}-${date.day}`;
      this.seeInstructorData.authorizeDate = {
        year: date.year,
        month: date.month,
        day: date.day,
      };
      this.isShowSeeInstructor = true;
    },
    seeInstructorLook() {
      this.isShowSeeInstructorLook = true;
    },
    // 弹窗 查看指导老师 提交
    seeInstructorSubmit() {
      this.$refs["seeInstructorRef"].validate((valid) => {
        if (valid) {
          // const data = deepClone(this.seeInstructorData);
          const {
            paper_plan_student_id,
            declaration_sign_img,
            sign_data,
            authorize_sign_img,
            authorize_sign_data,
          } = this.seeInstructorData;
          const data = {
            paper_plan_student_id,
            declaration_sign_img,
            sign_data,
            authorize_sign_img,
            authorize_sign_data,
          };
          studentSubmitDeclaration(data).then(res => {
            if (res.code == 200) {
              this.$message.success('提交成功');
              this.isShowSeeInstructor = false;
              this.getStudentPpsInfoData();
            }
          });
        }
      });
    },
    // 弹窗 查看指导老师 关闭
    seeInstructorClose() {
      this.seeInstructorData = {
        paper_plan_student_id: '',  //学生毕业设计及答辩id
        declaration_sign_img: '',  //原创性声明学生手写签名
        sign_data: '',  //签名日期
        authorize_sign_img: '',  //授权书学生手写签名
        authorize_sign_data: '',  //授权书签名日期
        // 原创性日期
        declarationDate: {
          year: '',  //签名日期 年
          month: '',  //签名日期 月
          day: '',  //签名日期 日
        },
        // 授权书学生日期
        authorizeDate: {
          year: '',  //签名日期 年
          month: '',  //签名日期 月
          day: '',  //签名日期 日
        },
        // 授权书导师日期
        mentorDate: {
          year: '',  //签名日期 年
          month: '',  //签名日期 月
          day: '',  //签名日期 日
        },
      };
      if(this.$refs['esignHandle1']){
        this.$refs['esignHandle1'].handleReset();  //签名这块清空
      }
      if(this.$refs['esignHandle2']){
        this.$refs['esignHandle2'].handleReset();  //签名这块清空
      }
      this.$nextTick(() => {
        this.$refs['seeInstructorRef'].clearValidate();
      });
    },
    seeInstructorLookClose() {
      this.isShowSeeInstructorLook = false;
    },
    // 弹窗 查看指导老师 日期处理
    inputChange(v, key, dataName, currName) {
      let obj = this[dataName][currName];
      if (obj.year && obj.month && obj.day) {
        this[dataName][key] = `${obj.year}-${obj.month}-${obj.day}`;
      }
    },
    // 弹窗 毕设报名 提交
    graduationRegistrationSubmit() {
      this.$refs["graduationRegistrationRef"].validate((valid) => {
        if (valid) {
          // if(
          //     !this.graduationRegistrationData.computer_score_img &&
          //     !this.graduationRegistrationData.english_score_img &&
          //     !this.graduationRegistrationData.average_score_img
          // ){
          //     return this.$message.warning('计算机成绩照片、英语成绩照片、平均成绩照片至少上传一个');
          // }
          const data = deepClone(this.graduationRegistrationData);
          studentSubmitSign(data).then(res => {
            if (res.code == 200) {
              this.$message.success('提交成功');
              this.isShowGraduationRegistration = false;
              this.getStudentPpsInfoData();
            }
          });
        }
      });
    },
    // 毕设报名
    graduationRegistrationClick(row) {
      this.graduationRegistrationData.paper_plan_student_id = this.condition.paper_plan_id;
      this.isShowGraduationRegistration = true;
    },
    // 弹窗 毕设报名 关闭
    graduationRegistrationClose() {
      this.graduationRegistrationData = {
        id: '',  //学生毕业设计及答辩id
        is_read: '',  //是否阅读报名须知 0否 1是
        student_sign_img: '',  //学生手写签名
        is_degree: 1,  //是否需要学位 0否 1是
        computer_score_img: '',  //计算机成绩照片
        english_score_img: '',  //英语成绩照片
        average_score_img: '',  //平均成绩照片
      };
      if (this.$refs['uploadComputerScoreImg']) {
        this.$refs['uploadComputerScoreImg'].reset();
      }
      if (this.$refs['uploadEnglishScoreImg']) {
        this.$refs['uploadEnglishScoreImg'].reset();
      }
      if (this.$refs['uploadaverageScoreImg']) {
        this.$refs['uploadaverageScoreImg'].reset();
      }
      if(this.$refs['esignHandle']){
        this.$refs['esignHandle'].handleReset();  //签名这块清空
      }
      this.$nextTick(() => {
        this.$refs['graduationRegistrationRef'].clearValidate();
      });
    },
    // 弹窗 毕设报名 签名成回调
    studentSignImgAfter(v, refName, field) {
      this.$refs[refName].validateField(field);
    },
    // 弹窗 毕设报名 上传
    degreeFileChange(data, type, dataName) {
      uploadFiles(data.fileList, async (urls) => {
        this[dataName][type] = urls;
      })
    },
    // 弹窗 毕设报名 文件删除
    degreeFileRemove(data, type, dataName) {
      this[dataName][type] = data.fileList;
    },
    // 获取毕设学生详情
    getStudentPpsInfoData() {
      const data = {
        paper_plan_student_id: this.condition.paper_plan_id,
      };
      studentPpsInfo(data).then(res => {
        if (res.code == 200) {
          this.studentInfo = res.result;

          if (res.result.config_content) {
            const configContent = JSON.parse(res.result.config_content);
            this.list = this.graduateDefenseDataGetHandle(configContent);
            // this.list[0].deadline = this.studentInfo.sign_deadline;
            // this.list[1].deadline = this.studentInfo.report_deadline;
            // this.list[2].deadline = this.studentInfo.one_deadline;
            // this.list[3].deadline = this.studentInfo.two_deadline;
            // this.list[4].deadline = this.studentInfo.three_deadline;
            // this.list[5].deadline = this.studentInfo.defense_reply_deadline;
            // this.list[6].deadline = this.studentInfo.cross_deadline;
            // this.list[7].deadline = this.studentInfo.defense_deadline;
            // this.list[8].deadline = this.studentInfo.score_reply_deadline;
          }
        }
      });
    },
    // 毕设数据处理 获取
    graduateDefenseDataGetHandle(data) {
      let arr = [];
      for (let key in data) {
        let item = data[key];
        arr.push({
          stepName: item.stepName,
          deadline: item[`${key}_deadline`],
          week: item.week,
          process: item.process,
        });
      }
      return arr;
    },
    // 获取论文计划
    getThesisPlanList() {
      adultStudentPpAll().then(res => {
        this.thesisPlanList = res.result;
      });
    },
    // 选择资料确认
    loadData() {
      this.$refs["search"].validate((valid) => {
        if (valid) {
          this.isShowTble = true;
          this.getStudentPpsInfoData();
        }
      });
    },
    // 合并行/列
    tableSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex === 2) {
          return [3, 1];
        }
        if (rowIndex === 3 || rowIndex === 4) {
          return [0, 0];
        }
      }
    },
  },
  beforeDestroy() {

  },
};
</script>

<style lang="scss">
@mixin floorBotStyle() {
  .floor-bot {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & + .floor-bot {
      margin-top: 0;
    }

    .el-form-item {
      width: 50%;
    }

    .date-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .input {
        input {
          width: 50px;
          border: none;
          text-align: center;
          padding: 0;
        }

        &:nth-child(1) {
          input {
            width: 60px;
          }
        }
      }

      .text {
        &.value {
          display: inline-block;
          width: 50px;
          text-align: center;
        }
      }
    }
  }
}

@mixin assignmentContStyle() {
  border: 1px solid #ccc;

    .floor {
      &.border-b {
        border-bottom: 1px solid #ccc;
      }

      .required::before {
        content: '*';
        color: #EF3333;
        margin-right: 4px;
      }

      .cont-title {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        height: 60px;
        line-height: 60px;
      }

      .border-r {
        border-right: 1px solid #ccc;
      }

      &.info-box {
        display: flex;
        height: 40px;
        line-height: 40px;

        .item {
          flex: 1;
          padding: 0 10px;

          .name,
          .value {
          }
        }
      }

      .item-title {
        padding: 0 10px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
      }

      &.textarea {
        padding: 0 10px;

        .el-textarea {
          padding-bottom: 20px;

          .el-textarea__inner {
            border: none;
            /*隐藏滚动条*/
            &::-webkit-scrollbar {
              display: none;
            }
          }
        }
      }

      &.table {
        .table-cont {
          padding: 10px;

          .table-box {
            width: 100%;

            .cell {
              padding: 10px 5px;
              text-align: center;

              &.week {
                width: 80px;
              }

              &.cont {

              }

              &.operate {
                width: 140px;
              }

              &.time{
                width: 100px;
              }

              &.time-value {
                width: 200px;
              }

              &.left{
                text-align: left;
              }

              @include floorBotStyle();

              .radio-box {
                display: flex;

                .el-form-item {
                  width: 100%;

                  .el-form-item__content {
                    text-align: left;

                    .el-radio {
                      margin-right: 100px;

                      &:last-child {
                        margin-right: 0;
                      }

                      // .el-radio__input{
                      //     &.is-checked{
                      //         .el-radio__inner{
                      //             background-color: #fff;
                      //         }
                      //     }
                      //     .el-radio__inner{
                      //         border-radius: 0;
                      //         &::after {

                      //         }
                      //     }
                      // }
                    }
                  }
                }
              }
            }

          }
        }

        table, th, td {
          border: 1px solid #ccc;
          border-collapse: collapse; /* 移除单元格之间的间隔 */
        }
      }

      &.bot {
        display: flex;
        justify-content: space-between;
        padding: 10px;

        .item {
          width: 48%;
        }
      }
    }
}

.graduateDefense {
  .see-img{
    width: 50px;
    height: 50px;
    object-fit: contain;
  }
  .el-scrollbar {
    padding-bottom: 20px;

    .el-scrollbar__wrap {
      overflow-x: hidden; // 隐藏自带的滚动条
    }
  }

  // 毕设报名
  .graduationRegistration {
    .el-scrollbar {
      position: relative;
      padding-bottom: 50px;

      .page-box {
        position: absolute;
        bottom: 0;
        left: 0;

        .text {
          display: inline-block;
          min-width: 60px;
          margin-right: 10px;
        }
      }
    }
  }

  // 指导教师
  .seeInstructor {
    .cont {
      .floor {
        border: 1px solid #ccc;
        padding: 10px;
        margin-bottom: 20px;

        .floor-title {
          font-size: 16px;
          font-weight: bold;
          text-align: center;
        }

        .floor-text {
          margin-top: 10px;

          .text {
            font-size: 15px;
            text-indent: 20px;
          }
        }

        @include floorBotStyle();
      }
    }
  }

  // 填写任务书
  .assignment {
    .cont {
      @include assignmentContStyle();
    }
  }
}
.assignmentPDF{
  @include assignmentContStyle();
  .el-form-item__content {
    line-height: normal;
  }
}
.proposalPDF-box{
  .assignment-pdf-cover {
    //height: 780px;
    min-height: 760px;
  }
  .title-box{
    .title1{
      font-size: 36px;
      text-align: center;
      font-weight: bold;
    }
    .title2{
      font-size: 24px;
      text-align: center;
    }
  }
  .el-form-item__content {
    line-height: normal;
  }
  .cover-box{
    width: 400px;
    margin: 0 auto;
    margin-top: 200px;
    .item{
      display: flex;
      height: 50px;
      & + .item{
        margin-top: 10px;
      }
      .name{
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
      }
      .value{
        width: calc(100% - 100px);
        font-size: 18px;
        border-bottom: 1px solid #999;
        display: flex;
        align-items: center;
      }
    }
  }
  .proposalPDF{
    margin-top: 400px;
    @include assignmentContStyle();
    .el-radio__input{
      &.is-disabled{
        &.is-checked{
          .el-radio__inner{
            &::after {
                background-color: #C0C4CC;
            }
          }
        }
      }
      .el-radio__inner{
        position: relative;
        &::after {
          content: '';
          display: inline-block;
          width: 4px;
          height: 4px;
          border-radius: 100%;
          background-color: #FFF;
          position: absolute;
          left: calc(50% - 2px);
          top: calc(50% - 2px);
          transform: scale(0);
          // left: 50%;
          // top: 50%;
          // transform: translate(-50%, -50%) scale(0);
          transition: transform .15s ease-in;
        }
      }
      &.is-checked{
        .el-radio__inner{
          &::after {
              // transform: translate(-50%, -50%) scale(1);
              transform: scale(1);
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.graduateDefense {
  min-height: $contentH;
  padding: $sideMargin;
  padding-bottom: 0;

  .cont-box {
    background: $white;
    min-height: inherit;
    padding: 0 20px 20px;

    .title {
      .btn-box {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>
